import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'
import { Polygon } from 'components/polygon'
import useWindowSize from 'hooks/useWindowSize'
import { theme } from 'styles/theme'

import * as S from './styles'

type Props = {
  onCtaClick: () => void
}

export const CondominiumCreditAbout = memo(({ onCtaClick }: Props) => {
  const { isTablet } = useWindowSize()

  return (
    <S.Section $bg="medium" aria-labelledby="condominium-credit-about-title">
      <Grid col={{ phone: 1, tablet: 12, desktop: 12 }}>
        <Col col={{ tablet: 4, desktop: 4 }} start={{ tablet: 2, desktop: 2 }}>
          <Text id="condominium-credit-about-title" as="h2" size="heading2" weight="medium">
            O que é o <S.Highlight>Crédito para Condomínios?</S.Highlight>
          </Text>
          {isTablet && (
            <Button
              aria-label="Solicitar uma simulação de crédito para condomínios"
              size="lg"
              type="button"
              variants="text-only"
              onClick={onCtaClick}
            >
              <span>Solicitar uma simulação</span>
            </Button>
          )}
        </Col>

        <Col col={{ tablet: 5, desktop: 5 }} start={{ tablet: 7, desktop: 7 }}>
          {isTablet && (
            <Polygon
              aria-hidden
              type="TriangleRound"
              width={80}
              height={100}
              draw="fill"
              color={theme.colors['cashme-magenta']}
              className="background-polygon polygon-pink"
            />
          )}
          <S.Infos>
            <Text size="body1" color="var(--colors-neutral-text-default)">
              Melhorias não precisam ficar esperando anos pelo acúmulo de recursos no fundo de reserva. O{' '}
              <b>Empréstimo para Condomínio</b> é uma alternativa para que o empreendimento avalie a contratação de
              recursos e distribua o pagamento conforme as condições aprovadas.
            </Text>
            <S.BulletList>
              <li>
                <Text size="body1" color="var(--colors-neutral-text-default)">
                  Mais clareza
                </Text>
              </li>
              <li>
                <Text size="body1" color="var(--colors-neutral-text-default)">
                  Previsibilidade
                </Text>
              </li>
              <li>
                <Text size="body1" color="var(--colors-neutral-text-default)">
                  Responsabilidade
                </Text>
              </li>
            </S.BulletList>
            {!isTablet && (
              <Button
                aria-label="Solicitar uma simulação de crédito para condomínios"
                size="lg"
                type="button"
                variants="text-only"
                onClick={onCtaClick}
              >
                <span>Solicitar uma simulação</span>
              </Button>
            )}
          </S.Infos>
        </Col>
      </Grid>
    </S.Section>
  )
})

CondominiumCreditAbout.displayName = 'CondominiumCreditAbout'
